





































































import { Component, Vue } from "vue-property-decorator";
import PersonSelectCard from "./PersonSelectCard.vue";
import {
    InsuranceCard,
    Driver,
    DriverType,
    Person
} from "@/services/index.defs";
import { DefaultCopy } from "_P/copyobj";

@Component({ components: { PersonSelectCard } })
export default class PersonSelect extends Vue {
    isDev = process.env.NODE_ENV == "development";
    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }

    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }

    goBack() {
        let stepNum = 4;
        if (this.isFastCalcDisabled) {
            stepNum = 3;
        }
        this.$router.push({ name: 'precheck', params: { step: `${stepNum}` } });
    }

    setInsurer(driver: Driver) {
        if (!!driver) {
            driver.type = DriverType.Insurer;
            let tempCopy = DefaultCopy(driver.person) as Person;
            tempCopy.address = this.card.insurer.address;
            this.$emit("setInsurer", tempCopy);
        } else this.$emit("setInsurer", null);
    }
    setInsurerIsOwner(owner: Person) {
        this.$emit("setInsurer", owner);
    }
}
